<template>
  <div>
    <div class="bg_top xs-hidden"></div>
    <div class="bg_bottom xs-hidden"></div>
    <div id="main" class="site-main">
      <div class="center-vertical">
        <div class="alert alert-danger" v-if="formErrors">
          Connexion échouée. Vérifiez votre login et votre mot de passe.
        </div>
        <div v-if="maintenance" class="alert alert-danger">
          Pour des raisons techniques, votre MyABFT est temporairement indisponible.
        </div>

        <div v-if="!maintenance" class="loginBox login-box-body overlay-wrapper">
          <div class="overlay" v-if="loggingIn">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
          <div class="blue"></div>
          <div class="inner">
            <div class="header">
              <div class="logo">
                <img src="../assets/img/logos/logoExtranetMini.png" alt="">
              </div>
              <div class="title">MYABFT</div>
              <div class="subtitle">CONNEXION</div>
            </div>
            <div class="body">
              <form>
                <div class="form-group">
                  <label class="col-md-4 control-label" style="color:white">Licence N°</label>
                  <div class="col-md-12">
                    <input type="text"
                           v-model="credentials.username"
                           placeholder="Licence N°" class="inputLogin form-control">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-4 control-label" style="color:white">Mot de passe</label>
                  <div class="col-md-12">
                    <input name="password" type="password" v-model="credentials.password" placeholder="Mot de passe"
                           class="inputLogin form-control">
                  </div>
                </div>
                <div class="form-group">
                  <!--<label class="col-md-4 control-label">Mot de passe</label>-->
                  <div class="col-md-12">
                    <button type="submit"
                            @click.prevent="sendLoginForm()"
                            class="btn btn-primary form-control">Se connecter
                    </button>
                  </div>
                </div>
              </form>
              <div class="form-group bodyBottom">
                <!--<label class="col-md-4 control-label">Mot de passe</label>-->
                <!--<div class="col-md-6">-->
                <!--Se souvenir de moi ?-->
                <!--</div>-->
                <div class="col-md-12">
                  <a href="http://www.abft.be">Retour au site</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.login-box {
  position: relative
}

.title {
  line-height: 32px;
}

.subtitle {
  font-size: 14px;
  line-height: 20px;
}

</style>

<script type="text/babel">
import Auth from '@/auth'
import {mapGetters, mapActions} from 'vuex'

export default {
  data() {
    return {
      credentials: {
        username: process.env.NODE_ENV == 'development' ? process.env.LOGIN : '',
        password: process.env.NODE_ENV == 'development' ? process.env.PASSWORD : ''
      },
      loggingIn: false,
      formErrors: false,
      maintenance: false,
    }
  },
  components: {},
  mounted: function () {
    this.checkVersion();
    this.checkMaintenance();
  },
  methods: {
    ...mapActions({
      setMember: 'setMember'
    }),
    checkVersion: function () {
      this.$http.get(process.env.API_URL + ('versionMyabft')).then((response) => {
        if (response.body != this.getProdVersion)
          location.reload(true);
      }, (response) => {
      });
    },
    checkMaintenance: function () {
      this.$http.get(process.env.API_URL + ('maintenanceMyabft')).then((response) => {
        this.maintenance = response.body=='1'
      }, (response) => {
      });
    },
    sendLoginForm: function () {
      this.loggingIn = true
      const credentials = {
        username: this.credentials.username,
        password: this.credentials.password
      }
      // Auth.login() returns a promise. A redirect will happen on success.
      // For errors, use .then() to capture the response to output
      // error_description (if exists) as shown below:
      this.$auth.login(credentials, 'Profile').then((response) => {
        this.loggingIn = false
        this.formErrors = true
        this.$http.post(process.env.API_URL + "getInfosMember").then((response) => {
          this.setMember(response.body)
        })
      })
    }
  },
  computed: {
    ...mapGetters({
      getProdVersion: 'getProdVersion'
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue